'use client';

import AppImage from '@/components/ui/AppImage';
import Icon from '@/components/ui/AppIcon';

export default function HeroSection() {
  return (
    <section className="relative h-[600px] lg:h-[700px] overflow-hidden">
      <div className="absolute inset-0">
        <AppImage
          src="/assets/images/pexels-snowfly09-32575068-1782554511100.jpg"
          alt="Bengaluru cityscape with modern buildings and lush greenery under colorful sunset sky"
          className="w-full h-full object-cover"
          priority
        />
        <div className="absolute inset-0 bg-gradient-to-r from-primary/95 via-primary/80 to-transparent" />
      </div>

      <div className="relative h-full flex items-center">
        <div className="container mx-auto px-4 lg:px-8">
          <div className="max-w-3xl space-y-6">
            <div className="inline-flex items-center space-x-2 bg-white/10 backdrop-blur-sm px-4 py-2 rounded-full">
              <Icon name="BriefcaseIcon" size={20} className="text-accent" />
              <span className="text-white text-sm font-medium">Enterprise Accommodation Solutions</span>
            </div>
            <h1 className="text-4xl lg:text-6xl font-display font-bold text-white leading-tight">
              Corporate Solutions for Modern Business
            </h1>
            <p className="text-lg lg:text-xl text-white/90">
              Comprehensive accommodation solutions designed for corporate travel managers and business clients. Flexible packages, dedicated support, and seamless booking management for your entire organization.
            </p>
            <div className="flex flex-col sm:flex-row gap-4 pt-4">
              <a
                href="#packages"
                className="px-8 py-4 bg-accent hover:bg-accent/90 text-white font-semibold rounded-lg shadow-elevated transition-all duration-300 hover:scale-105 flex items-center justify-center space-x-2"
              >
                <span>View Packages</span>
                <Icon name="DocumentTextIcon" size={20} className="text-white" />
              </a>
              <a
                href="#contact"
                className="px-8 py-4 bg-white/10 backdrop-blur-sm hover:bg-white/20 text-white font-semibold rounded-lg border-2 border-white/30 transition-all duration-300 flex items-center justify-center space-x-2"
              >
                <span>Contact Sales</span>
                <Icon name="PhoneIcon" size={20} className="text-white" />
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}